import {
  GET_TERMS_CONDITIONS,
  CREATE_TERMS_CONDITIONS,
  UPDATE_TERMS_CONDITIONS,
  DELETE_TERMS_CONDITIONS,
  GET_TERMS_CONDITIONS_REQUEST_PENDING,
  GET_TERMS_CONDITIONS_REQUEST_SUCCESS,
  GET_TERMS_CONDITIONS_REQUEST_ERROR,
  CHANGE_TERMS_CONDITIONS_REQUEST_PENDING,
  CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS,
  CHANGE_TERMS_CONDITIONS_REQUEST_ERROR,
} from '../types/termsConditions'

const initialState = {
  items: [],
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const termsConditions = (state = initialState, action) => {
  switch (action.type) {
    case GET_TERMS_CONDITIONS:
      return { ...state, items: action.payload || [] }

    case CREATE_TERMS_CONDITIONS:
      return {
        ...state,
        items: [...state.items.filter((item) => item.type !== action.payload.type), action.payload],
      }

    case UPDATE_TERMS_CONDITIONS:
      return {
        ...state,
        items: state.items.map((item) => (item.id === action.payload.id ? action.payload : item)),
      }

    case DELETE_TERMS_CONDITIONS:
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      }

    case GET_TERMS_CONDITIONS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }

    case GET_TERMS_CONDITIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }

    case GET_TERMS_CONDITIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }

    case CHANGE_TERMS_CONDITIONS_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }

    case CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }

    case CHANGE_TERMS_CONDITIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }

    default:
      return state
  }
}

export default termsConditions
